import React, {useRef} from "react";
import {Grid, IconButton, Typography} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import moment from "moment";
import {makeStyles} from "@material-ui/core/styles";
import {Button, EnrollmentFileUploader as FileUploader} from "../../../../../components/formInputs";
import GetAppIcon from "@material-ui/icons/GetApp";
import * as ClientActions from "../../../../../actions/client";
import * as AccountActions from "../../../../../actions/account";
import * as AwsActions from "../../../../../actions/aws";
import {useActions} from "../../../../../actions";
import {asDbDateFormat, DATE_FORMAT_DOB_SAVE} from "../../../../../utils/dateUtils";
import ConfirmToUploadPolicyDoc from "../ConfirmToUploadPolicyDoc";
import { removeWord } from "../../../../../utils/commonUtils";

const useStyles = makeStyles({
    table: {
        minWidth: 767,
    },
    tableHead: {
        backgroundColor: "#EDF3F8",
    },
});
const DocArr = ["Annual Statement", "Confirmation Statement"]
const HiddenFileUploader = (props: {
    uploadRef: any,
    fileType: string,
    statementType: string,
    enrollmentId: string,
    policyYear: number,
    setPolicyStatements: Function,
    clientPolicyId: string,
    policyBreakdownId: number
}) => {
    const clientAction = useActions(ClientActions);
    const AccountAction = useActions(AccountActions);
    const {
        uploadRef,
        fileType,
        statementType,
        enrollmentId,
        policyYear,
        setPolicyStatements,
        clientPolicyId,
        policyBreakdownId,
    } = props;
    const checkInvalidFile = () => {
        AccountAction.alertPopup("Documents must be .pdf")
    }

    return (
            <FileUploader
                    uploadRef={uploadRef}
                    dirName={enrollmentId + "/scrapedstatements"}
                    dirType={"documents"}
                    fileType={fileType}
                    content={"Uploads"}
                    checkInvalidFile={checkInvalidFile}
                    exactFileName={policyYear + "_" + statementType}
                    onFinish={async (publicUrl: string, name: string) => {
                        const newStatement = {
                            statementType: statementType,
                            statementPath: "scrapedstatements/" + name,
                            statementDate: moment().format(DATE_FORMAT_DOB_SAVE),
                            primaryStatement: true,
                            clientPolicyId,
                            policyBreakdownId
                        };
                        setPolicyStatements((prev: any[]) => {
                            const filtered = prev.filter(s => s.statementType !== statementType);
                            return [...filtered, newStatement];
                        });
                        await clientAction.updatePolicyDocument({
                            statementType: statementType,
                            statementPath: "scrapedstatements/" + name,
                            primaryStatement: true,
                            clientPolicyId,
                            policyBreakdownId
                        });
                    }}
            />
    );
};

export default function PolicyYearDocTable(props: { yearPolicyBreakup: any, caseDetails: any }) {
    const classes = useStyles();
    const awsActions = useActions(AwsActions);
    const {yearPolicyBreakup, caseDetails} = props;
    const strategyName = caseDetails && caseDetails.strategy && (caseDetails.strategy.text || caseDetails.strategy.name) || "Kai-Zen";
    const uploadRef = useRef<any>(null);
    const [statementType, setStatementType] = React.useState("");
    const fileType: string = "application/pdf";
    const [policyStatements, setPolicyStatements] = React.useState<any[]>([]);
    const [confirmationBox, setConfirmationBox] = React.useState(false);
    const enrollmentId = caseDetails && caseDetails.enrollment && caseDetails.enrollment.id;

    const getStatement = (type: string) => {
        return policyStatements.find(s => s.statementType === type);
    };

    const annualStatement = getStatement(DocArr[0]);
    const interestStatement = getStatement(DocArr[1]);

    React.useEffect(() => {
        if (yearPolicyBreakup && yearPolicyBreakup.policyStatements) {
            setPolicyStatements(yearPolicyBreakup.policyStatements);
        }
    }, [yearPolicyBreakup])

    const handleDocument = async (document: any) => {
        const contentType = "text/pdf";
        let queryObj = {
            objectName: document,
            contentType: contentType,
        };
        const s3url = await awsActions.getSecureUrlAndDownload(enrollmentId, queryObj, true);
        let blob = new Blob([new Buffer(s3url.Body, "binary")]
                , { type: s3url.ContentType });
        const url = window.URL.createObjectURL(blob);
        const link = window.document.createElement("a");
        link.href = url;
        link.setAttribute("download", removeWord(document, "scrapedstatements/"));
        window.document.body.appendChild(link);
        link.click();
    }

    const handleYes = () => {
        if (uploadRef && uploadRef.current) {
            uploadRef.current.click();
            setConfirmationBox(false);
        }
    }

    return (
            <Grid item xs={12}>
                <span className="hLine"/>
                <Typography variant="body1" component="strong" className="mb20 floatLeft w100">Documents&nbsp;
                </Typography>
                <Typography variant="body1" component="strong" className="mb20 floatLeft w100">

                </Typography>
                <TableContainer>
                    <Table className={classes.table} aria-label="caption table">
                        <TableHead className={classes.tableHead}>
                            <TableRow>
                                <TableCell>Document Name</TableCell>
                                <TableCell>Upload Date</TableCell>
                                <TableCell>File Name</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <span className="floatLeft">Carrier Annual Statement</span>
                                    <div className="floatRight btnwrap">
                                        <Button size="small" className="floatLeft" type="button" variant="contained"
                                                color="primary"
                                                disabled={false}
                                                label={annualStatement && annualStatement.statementPath ? "Upload New Pdf" : "Upload Pdf"}
                                                onClick={() => {
                                                    setStatementType(DocArr[0]);
                                                    if (annualStatement && annualStatement.statementPath) {
                                                        setConfirmationBox(true);
                                                    }
                                                    if (!(annualStatement && annualStatement.statementPath) && uploadRef && uploadRef.current) {
                                                        uploadRef.current.click();
                                                    }
                                                }}/>
                                        {
                                            annualStatement && annualStatement.statementPath &&
                                            <IconButton className="floatLeft ml20 mt5" aria-label="delete"
                                                        size="small"
                                                        onClick={() => handleDocument(annualStatement.statementPath)}>
                                                <GetAppIcon/>
                                            </IconButton>
                                        }
                                    </div>
                                </TableCell>
                                {annualStatement && annualStatement.statementPath ?
                                        <>
                                            <TableCell>{asDbDateFormat(annualStatement.statementDate)}</TableCell>
                                            <TableCell>{removeWord(annualStatement.statementPath,'scrapedstatements/')}</TableCell>
                                        </> : <TableCell colSpan={2} className="colorLightBlack">currently no uploaded
                                            doc</TableCell>
                                }
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <span className="floatLeft">Confirmation Statement</span>
                                    <div className="floatRight btnwrap">
                                        <Button size="small" type="button" variant="contained" color="primary"
                                                disabled={false}
                                                label={interestStatement && interestStatement.statementPath ? "Upload New Pdf" : "Upload Pdf"}
                                                className="floatLeft"
                                                onClick={() => {
                                                    setStatementType(DocArr[1]);
                                                    if (interestStatement && interestStatement.statementPath) {
                                                        setConfirmationBox(true);
                                                    }
                                                    if (!(interestStatement && interestStatement.statementPath) && uploadRef && uploadRef.current) {
                                                        uploadRef.current.click();
                                                    }
                                                }}/>
                                        {
                                            interestStatement && interestStatement.statementPath &&
                                            <IconButton className="floatLeft ml20 mt5" aria-label="delete"
                                                        size="small"
                                                        onClick={() => handleDocument(interestStatement.statementPath)}>
                                                <GetAppIcon/>
                                            </IconButton>
                                        }

                                    </div>
                                </TableCell>
                                {
                                    interestStatement && interestStatement.statementPath ? <>
                                                <TableCell>{asDbDateFormat(interestStatement.statementDate)}</TableCell>
                                                <TableCell>{removeWord(interestStatement.statementPath,'scrapedstatements/')}</TableCell>
                                            </>
                                            : <TableCell colSpan={2} className="colorLightBlack">currently no uploaded
                                                doc</TableCell>
                                }
                            </TableRow>
                        </TableBody>
                        <div className="fileUpload" style={{display: "none"}}>
                            <HiddenFileUploader
                                                uploadRef={uploadRef}
                                                fileType={fileType}
                                                statementType={statementType}
                                                enrollmentId={enrollmentId}
                                                policyYear={yearPolicyBreakup.policyYear}
                                                setPolicyStatements={setPolicyStatements}
                                                clientPolicyId={yearPolicyBreakup.clientPolicyId}
                                                policyBreakdownId={yearPolicyBreakup.id}
                            />
                        </div>
                        <ConfirmToUploadPolicyDoc confirmationBox={confirmationBox} setConfirmationBox={setConfirmationBox}
                            handleYes={handleYes}
                        />
                    </Table>
                </TableContainer>
            </Grid>
    );
}